<template>
  <div class="bg-white flex justify-center items-center absolute inset-0">
    <GrmLoadingCircle />
  </div>
</template>

<script>
import {mapState} from "vuex";

import GrmLoadingCircle from "@/components/Common/loading/GrmLoadingCircle.vue";

export default {
  name: 'RoomExamLoading',
  components: {
    GrmLoadingCircle
  },
  computed: {
    ...mapState('exam', [
      'bankExam',
    ]),
  },
}
</script>